import ReactDOM from 'react-dom';

export default ({ children }: { children: any }) =>
  ReactDOM.createPortal(children, document.getElementsByTagName('body')[0]);
